(function () {
  var MIN = 3;
  var MAX = 12;

  var visitorKey = "zam_fomo_visitor_seed_v1";
  var visitorSeed = Number(localStorage.getItem(visitorKey));
  if (!visitorSeed) {
    visitorSeed = Math.floor(Math.random() * 1000000) + 1;
    localStorage.setItem(visitorKey, String(visitorSeed));
  }

  function seededRandom(seed) {
    seed = (seed * 9301 + 49297) % 233280;
    return seed / 233280;
  }

  function numberForProduct(productId) {
    var seed = visitorSeed + (Number(productId) || 0);
    var r = seededRandom(seed);
    return Math.floor(r * (MAX - MIN + 1)) + MIN;
  }

  function apply() {
    document.querySelectorAll(".zam-fomo").forEach(function (el) {
      var pid = el.getAttribute("data-product-id");
      var countEl = el.querySelector(".zam-fomo-count");
      if (!countEl) return;
      countEl.textContent = numberForProduct(pid);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }
})();
setInterval(() => {
  document.querySelectorAll('.zam-fomo').forEach(el => {
    if (!el.dataset.loaded) {
      const min = 3;
      const max = 14;
      const count = Math.floor(Math.random() * (max - min + 1)) + min;
      el.querySelector('.zam-fomo-count').textContent = count;
      el.dataset.loaded = "true";
    }
  });
}, 1000);